import apiClient from "../common/apiClient";

async function getSchema( tableName ) {

    let response = await apiClient.get(`/api/schema/${tableName}`);

    return response.data;

}

export default getSchema;